<template>
  <div id="topScorer" >
    <van-nav-bar
      title="常规赛第一阶段(7支单循环)截止第7周"
      left-arrow
    />
    <van-tabs v-model="active">
      <van-tab title="积分榜"></van-tab>
      <van-tab title="射手榜"></van-tab>
    </van-tabs>
    <div class="title" >
      <ul>
        <li>球队</li>
        <li>胜利</li>
        <li>失败</li>
        <li>积分</li>
      </ul>
    </div>
    <div class="main" >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="item in list"
          :key="item"
          :title="item"
        />
      </van-list>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Search, List, NavBar, Tab, Tabs } from 'vant'
Vue.use(Search).use(List).use(NavBar).use(Tab).use(Tabs)
export default {
  name: 'ShowPlayer',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      active: 1
    }
  },
  mounted () {},
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1)
        }
        // 加载状态结束
        this.loading = false

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true
        }
      }, 500)
    }
  },
  computed: {}
}
</script>
<style>
  #topScorer .title {
    padding: 10px 0;
  }

  #topScorer .title ul {
    display: flex;
  }

  #topScorer .title ul li {
    flex: 1;
    text-align: center;
  }

  #topScorer .main {
    position: absolute;
    width: 100%;
    height: calc(100% - 200px);
    overflow: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/top-scorer-list.vue